import { isBankiRu } from 'partners/banki-ru/isBankiRu';
import { Partner } from 'partners/Partner';

/**
 * @description Function for get current partner.
 * @returns {Partner | null} Partner Enum which corresponds current partner or null - if no partner is suitable.
 */
export function getCurrentPartner(): Partner | null {
    if (isBankiRu()) {
        return Partner.BANKI_RU;
    }

    return null;
}
